/**
 * Nazwa zdarzenia okna, którym transport obrazu demonstracyjnego ogłasza
 * odmowę (ADR-0059). Osobny moduł, bez fikstur: `DemoNotice` słucha go
 * w KAŻDYM bundlu, a statyczny import transportu wciągnąłby fikstury do
 * obrazu produkcyjnego.
 */
export const DEMO_REFUSAL_EVENT = 'k1p4:demo-refusal'

/** Powody odmów — pole `reason` koperty błędu i klucz komunikatu `demo.refusal.*`. */
export const DEMO_REFUSAL_REASONS = [
  'demo-read-only',
  'demo-outside-snapshot',
  'demo-filter-unavailable',
  'demo-no-files',
  'demo-no-onboarding',
  'demo-fixture-missing',
] as const

export type DemoRefusalReason = (typeof DEMO_REFUSAL_REASONS)[number]
